import { render, staticRenderFns } from "./RamsFields.vue?vue&type=template&id=6078a0fa&"
import script from "./RamsFields.vue?vue&type=script&lang=js&"
export * from "./RamsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports